import { defineAsyncComponent } from 'vue'

const BusModuleSubsystemFormModal = defineAsyncComponent(
  () => import('./bus-module-subsystem-form-modal/bus-module-subsystem-form-modal.vue'),
)
const BusModuleSubsystemModal = defineAsyncComponent(
  () => import('./bus-module-subsystem-modal.vue'),
)

const BusModuleSubsystemsTable = defineAsyncComponent(
  () => import('./bus-module-subsystems-table.vue'),
)
const BusModuleSubsystem = defineAsyncComponent(() => import('./bus-module-subsystem.vue'))
const BusModuleSubsystemsSelect = defineAsyncComponent(
  () => import('./bus-module-subsystems-select.vue'),
)

export {
  BusModuleSubsystem,
  BusModuleSubsystemFormModal,
  BusModuleSubsystemModal,
  BusModuleSubsystemsSelect,
  BusModuleSubsystemsTable,
}
